<mat-form-field class="mat-select-sm" appearance="fill">
    <mat-select [(ngModel)]="selectedRemaining" (ngModelChange)="valueChanged()">
        <mat-option class="mat-option-sm" selected value="All">All</mat-option>
        <mat-option class="mat-option-sm" selected value="0.00">0.00</mat-option>
        <mat-option class="mat-option-sm" selected value=">0.00">>0.00</mat-option>
        <mat-option class="mat-option-sm red" selected value="Red">Red</mat-option>
        <mat-option class="mat-option-sm green" selected value="Green">Green</mat-option>
    </mat-select>
</mat-form-field>